import React, { type FC, type PropsWithChildren } from 'react';

import ABTest from '../../ab-test/ab-test';
import type { Lucid } from '../../../types/types';

export interface ABTestEnterpriseRedirectProps {
  willTriggerFire?: boolean;
  redirectPage: 'enterprise' | 'sales';
}

const ABTestEnterpriseRedirect: FC<PropsWithChildren<ABTestEnterpriseRedirectProps>> = ({
  willTriggerFire,
  redirectPage,
}) => {
  const getRedirectPath = (branch?: Lucid.ABTest.VariationKeys) => {
    switch (redirectPage) {
      case 'enterprise':
        return 'https://lucid.co/enterprise';
      case 'sales':
        return branch === 'T_C' ? 'https://lucid.co/contact/contact-sales' : undefined;
      default:
        return undefined;
    }
  };

  return (
    <ABTest
      isAboveTheFold
      branchesToRender={['T_A', 'T_B', 'T_C']}
      testName="FY25_LucidSuiteEnterpriseRedirects"
      trigger="redirect"
      willTriggerFire={willTriggerFire}
    >
      <ABTest.Branch branch="T_B" redirectPath={getRedirectPath('T_B')} />
      <ABTest.Branch branch="T_C" redirectPath={getRedirectPath('T_C')} />
    </ABTest>
  );
};

export default ABTestEnterpriseRedirect;
